export enum RelatedPartType {
    Alternative = 'Alternative',
    Replacement = 'Replacement',
    ChildBrandPart = 'ChildBrandPart',
}
